import React, { useEffect, useRef, useState } from 'react'
import {
  Box, ResponsiveBox, ResponsiveText, IcoMoon,
  CarIcon,
} from '@usap/uicomponents'
import { OverlaySpinner } from '@usap/widgets'
import useListenOnVehicleSelect from '../hooks/useListenOnVehicleSelect'
import useHandleAddVehicle from '../hooks/useHandleAddVehicle'
import useStyle from './useStyle'
import useWmoEnabled from '../../../../../../../hooks/useWmoEnabled'
import RequireVehicleInfoWmo from './RequireVehicleInfoWmo'

const RequireVehicleInfo = props => {
  const { data } = props
  const { product } = data

  const [showSpinner, shouldShowSpinner] = useState(false)
  const fitmentLabel = 'Vehicle Info Required to Guarantee Fit'
  const isWmoEnabled = useWmoEnabled()

  const handleAddVehicle = useHandleAddVehicle({
    product,
  })

  useListenOnVehicleSelect({
    shouldShowSpinner,
    product,
  })

  const style = useStyle()

  if (isWmoEnabled) {
    return <RequireVehicleInfoWmo product={product} showSpinner={showSpinner} shouldShowSpinner={shouldShowSpinner} isCartItem={true} />
  }

  return (
    <ResponsiveBox
      border={style.wrapperBorder}
      round="4px"
      pad={style.wrapperPad}
      fxMargin={style.wrapperFxMargin}
    >
      <Box direction="row" style={style.containerPosition}>
        <OverlaySpinner active={showSpinner} />
        <Box align="center" justify="center" style={style.iconWrapperMinWidth}>
          <Box
            justify="center"
            align="center"
            margin="xsmall"
            width="34px"
            height="34px"
            round="50%"
            background="#FF9700"
          >
            <IcoMoon
              icon={CarIcon}
              color="white"
              size="24px"
            />
          </Box>
        </Box>
        <Box pad={style.textWrapperPad} align="start" justify="center" width="100%">
          <ResponsiveText
            weight="bold"
            color="dark-2"
            fxSize={style.textFxSize}
          >
            {fitmentLabel}
          </ResponsiveText>

          <Box
            direction="row"
            align="center"
            justify="between"
            margin={style.linkMarginTop}
          >
            <ResponsiveText
              color="blueLink"
              weight="bold"
              fxSize={style.linkFxSize}
              onClick={handleAddVehicle}
              style={style.linkCursor}
            >
              Add Vehicle
            </ResponsiveText>
          </Box>

        </Box>
      </Box>
    </ResponsiveBox>
  )
}

export default RequireVehicleInfo
